export const CityRoad = ({ size = 24, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 20L2 20M19 4L5 4M3 16.01L3.01 15.9989M21.0098 16.01L20.9998 15.9989M4 12.01L4.01 11.9989M20.0098 12.01L19.9998 11.9989M5 8.01L5.01 7.99889M19.0098 8.01L18.9998 7.99889M12 7V17M12 7L10.5 8.5M12 7L13.5 8.5M12 17L9 14M12 17L15 14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
